import request from '../utils/request';

export default class BaseService<T> {
  protected serviceApi: string = '';
  protected searchApi: string = '/Search';
  protected createApi: string = '/Create';
  protected updateApi: string = '/Update';
  protected deleteApi: string = '/Delete';
  protected getAllApi: string = '/GetAll';
  protected getApi: string = '/Get';

  public Search(data: T, pageIndex?: number) {
    return request({
      url: this.serviceApi + this.searchApi + '/' + pageIndex,
      method: 'post',
      data: data,
    });
  }

  public Create(data: T) {
    return request({
      url: this.serviceApi + this.createApi,
      method: 'post',
      data: data,
    });
  }

  public Update(data: T) {
    return request({
      url: this.serviceApi + this.updateApi,
      method: 'put',
      data: data,
    });
  }

  public Delete(id: string | number) {
    return request({
      url: this.serviceApi + this.deleteApi + '/' + id,
      method: 'delete',
    });
  }

  public GetAll() {
    return request({
      url: this.serviceApi + this.getAllApi,
      method: 'get',
    });
  }

  public Get(id: string | number) {
    return request({
      url: this.serviceApi + this.getApi + '/' + id,
      method: 'get',
    });
  }

  public Post(data: T, api: string) {
    return request({
      url: this.serviceApi + api,
      method: 'post',
      data: data,
    });
  }

  public GetUrl(url: string) {
    return request({
      url: this.serviceApi + url,
      method: 'get',
    });
  }
}
